<template>
    <div id="main" class="Accelerometer">  
      <button id="accelPermsButton" @click="getAccel()" style="height:50px;">Get Accelerometer Permissions</button>
     `<div class="indicatorDot" style="left:30%; top:30%;"></div>
</div>



  
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Accelerometer',
  render: h => h(), 
  data: ()=>({

    accelerometerData: {},
    left: '*-*',
    right: '*-*'

  }),
  
  mounted() {


    this.$px = 50; // Position x and y
    this.$py = 50;
    this.$vx = 0.0; // Velocity x and y
    this.$vy = 0.0;
    this.$updateRate = 1/60; // Sensor refresh rate
    
   
  },
  methods: {

    getAccel(){


      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        DeviceMotionEvent.requestPermission()
          .then(response => {
            window.alert(response)
            if (response == 'granted') {
                window.addEventListener('deviceorientation',(event) => {
                  
                  // window.alert('deviceorientation')

                  const rotation_degrees = event.alpha;
                  const frontToBack_degrees = event.beta;
                  const leftToRight_degrees = event.gamma;
                
                  // Update velocity according to how tilted the phone is
                  // Since phones are narrower than they are long, double the increase to the x velocity
                  
                  this.$vx = this.$vx + leftToRight_degrees * this.$updateRate*2; 
                  this.$vy = this.$vy + frontToBack_degrees * this.$updateRate;
                  
                  // Update position and clip it to bounds

                  this.$px = this.$px + this.$vx*.5;
                  if (this.$px > 98 || this.$px < 0){ 
                      this.$px = Math.max(0, Math.min(98, this.$px)) // Clip this.$px between 0-98
                      this.$vx = 0;
                  }

                  this.$py = this.$py + this.$vy*.5;
                  if (this.$py > 98 || this.$py < 0){
                      this.$py = Math.max(0, Math.min(98, this.$py)) // Clip this.$py between 0-98
                      this.$vy = 0;
                  }
                  
                  dot = document.getElementsByClassName("indicatorDot")[0]
                  dot.setAttribute('style', "left:" + (this.$px) + "%;" + "top:" + (this.$py) + "%;");

              })
            }
          })
          // .catch(window.alert('error!'))
      } else {

        window.alert('NO DeviceMotionEvent')

      }

    },


    // onClick() {

    //   window.alert(typeof DeviceMotionEvent.requestPermission)


    //     if (typeof DeviceMotionEvent.requestPermission === 'function') {

    //       window.alert('is_function '+ DeviceMotionEvent.requestPermission())
    //       window.alert(DeviceMotionEvent.requestPermission())

    //         DeviceMotionEvent.requestPermission()
    //             .then(permissionState => {
    //                 if (permissionState === 'granted') {
    //                   window.alert('granted')
    //                 }
    //             })
    //             .catch(

    //               window.alert('error')

    //             );
    //     }
    // },





    // getAccel() {

    //   window.alert('xxx')
    //   window.alert(DeviceMotionEvent.requestPermission)

    //    DeviceMotionEvent.requestPermission().then(response => {


    //     console.log('x');

    //     if (response == 'granted') {
    //    // Add a listener to get smartphone orientation 
    //        // in the alpha-beta-gamma axes (units in degrees)

    //       window.alert(response)


    //         window.addEventListener('deviceorientation',(event) => {
    //             // Expose each orientation angle in a more readable way
    //             rotation_degrees = event.alpha;
    //             frontToBack_degrees = event.beta;
    //             leftToRight_degrees = event.gamma;
                
    //             // Update velocity according to how tilted the phone is
    //             // Since phones are narrower than they are long, double the increase to the x velocity
    //             this.$vx = vx + leftToRight_degrees * this.$updateRate*2; 
    //             this.$vy = vy + frontToBack_degrees * updateRate;
                
    //             // Update position and clip it to bounds
    //             this.$px = px + vx*.5;
    //             if (px > 98 || px < 0){ 
    //                 px = Math.max(0, Math.min(98, px)) // Clip px between 0-98
    //                 vx = 0;
    //             }

    //             py = py + vy*.5;
    //             if (py > 98 || py < 0){
    //                 py = Math.max(0, Math.min(98, py)) // Clip py between 0-98
    //                 vy = 0;
    //             }
                
    //             dot = document.getElementsByClassName("indicatorDot")[0]
    //             dot.setAttribute('style', "left:" + (px) + "%;" + "top:" + (py) + "%;");
                
    //         });
    //     }
    // });




    // },

    
  

  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Accelerometer
  position absolute 
  top 0 
  left 0
  width 100vw

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px
    opacity .5

    &.right 
      right 0
      
.indicatorDot
  width 30px
  height 30px
  background-color #ffab56
  border-radius 50%

</style>















